import type { AppConfig } from '@/config/AppConfig';

export const getConfig = (): { app: AppConfig; frontVersion: string; userEmail: string | null } => {
  const params = new URLSearchParams(self.location.search);

  const overrideMailUser = sessionStorage.getItem('OverrideMailUser');
  return {
    app: window.sgmeConfiguration,

    frontVersion: window.frontVersion,

    // Il faut revoir le default sur chain vide
    userEmail: overrideMailUser ?? params.get('user') ?? null,
  };
};
